import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=e7c67cf2&scoped=true&"
import script from "./Recaptcha.vue?vue&type=script&lang=js&"
export * from "./Recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c67cf2",
  null
  
)

export default component.exports